module.exports = __webpack_public_path__ + "static/media/drone.94758dcd.svg";